import { word } from "@modules/core/utils/i18n"
import { requiredInput } from "@modules/form/formUtils"
import { type SharedCoach } from "@modules/programs/types/programTypes"
import { type HUImage } from "@modules/types/imageTypes"
import * as Yup from "yup"

export type ProgramOnOffInputKey =
  | "image"
  | "name"
  | "visibility"
  | "description"
  | "defaultHideSessionContent"
  | "entranceCheckEnabled"
  | "duration"
  | "sharedCoaches"

export function getProgOnOffValidationSchema(options?: { imageRequired: boolean }) {
  return Yup.object({
    image: options?.imageRequired
      ? Yup.mixed().required(word("program.form.uploadImage.requiredText"))
      : Yup.object().nullable(),
    name: requiredInput(
      Yup.string()
        .max(255, word("form.maximum.characters", { count: 255 }))
        .trim(),
    ),
    description: requiredInput(Yup.string().trim()),
    duration: Yup.number()
      .min(1, word("program.duration.minimum.message"))
      .max(365, word("program.duration.maximum.message"))
      .required(word("global.form.required"))
      .integer(),
    programIdToDuplicate: Yup.string().nullable(),
  })
}

export type ProgramOnOffFormikType = {
  image?: HUImage
  title: string
  description: string
  visibility: boolean
  defaultHideSessionContent: boolean
  entranceCheckEnabled: boolean
  duration?: number
  sharedCoaches?: SharedCoach[]
  programIdToDuplicate?: string | null
}
